import React from 'react';
import './ServiceStats.css';

const statsData = [
    { img: 'https://images.seeklogo.com/logo-png/52/1/premium-quality-logo-png_seeklogo-520817.png?v=1958562903306059504', label: 'Premium Quality' },
    { img: 'https://cdn-icons-png.flaticon.com/512/10112/10112411.png', label: 'Cost-Effective' },
    { img: 'https://img.freepik.com/premium-vector/versatile-icon_946691-704.jpg', label: 'Versatility' },
    { img: 'https://png.pngtree.com/png-clipart/20230111/original/pngtree-ecology-sustainable-nature-planet-conversation-concept-png-image_8902973.png', label: 'Sustainability' },
    { img: 'https://png.pngtree.com/png-clipart/20240312/original/pngtree-light-bulb-creative-and-innovative-ideas-png-image_14568675.png', label: 'Innovative Design' },
    { img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQh-0rlWstWvNSY02Xarl6hUs7lUzJ00cYFKQ&s', label: 'Customer Satisfaction' },
    { img: 'https://t4.ftcdn.net/jpg/01/71/29/55/360_F_171295594_YthEz7WlJGqEPW9lUQQyNcx9rPZnw35K.webp', label: '24/7 Support' }, 
];

const ServiceStats = () => {
    return (
        <div className="container">
            <h1 
                className="text-center my-4" 
                style={{ fontFamily: 'Poppins', fontWeight: '600', paddingBottom: '30px', color: 'white' }}
            >
                Why Choose Seal Active
            </h1>
            <div className="row">
                {statsData.slice(0, 4).map((stat, index) => (
                    <div 
                        key={index} 
                        className="col-md-3 col-sm-6 mb-4" 
                        data-aos="fade-right" 
                        data-aos-delay={index * 100}
                    >
                        <div className="card">
                            <div className="card-body d-flex align-items-center">
                                <img 
                                    src={stat.img} 
                                    alt={stat.label} 
                                    className="card-img-top" 
                                    style={{ maxWidth: '60px', marginRight: '15px' }} 
                                />
                                <div>
                                    <p>{stat.label}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* Centered Row for Last Two Cards */}
            <div className="row justify-content-center">
                {statsData.slice(4, 6).map((stat, index) => (
                    <div 
                        key={index + 4} 
                        className="col-md-3 col-sm-6 mb-4 d-flex justify-content-center d-none d-sm-block" 
                        data-aos="fade-right" 
                        data-aos-delay={(index + 4) * 100}
                    >
                        <div className="card">
                            <div className="card-body d-flex align-items-center">
                                <img 
                                    src={stat.img} 
                                    alt={stat.label} 
                                    className="card-img-top" 
                                    style={{ maxWidth: '60px', marginRight: '15px' }} 
                                />
                                <div>
                                    <p>{stat.label}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* Single Centered Card Below */}
            <div className="row justify-content-center">
                <div 
                    className="col-md-3 col-sm-6 mb-4 d-flex justify-content-center d-none d-sm-block" 
                    data-aos="fade-right" 
                    data-aos-delay={600}
                >
                    <div className="card">
                        <div className="card-body d-flex align-items-center">
                            <img 
                                src="https://t4.ftcdn.net/jpg/01/71/29/55/360_F_171295594_YthEz7WlJGqEPW9lUQQyNcx9rPZnw35K.webp"
                                alt="24/7 Support" 
                                className="card-img-top" 
                                style={{ maxWidth: '60px', marginRight: '15px' }} 
                            />
                            <div>
                                <p>24/7 Support</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceStats;
